import script from "./myPasswordEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./myPasswordEdit.vue?vue&type=script&setup=true&lang=js"

import "./myPasswordEdit.vue?vue&type=style&index=0&id=655b22d9&scoped=true&lang=scss"

import exportComponent from "H:\\03_微压氧舱-张赟\\共享氧舱\\share-project-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-655b22d9"]])

export default __exports__